import { toast } from "react-toastify"
import HelpCenterAPI from "../../../api/helpCenter"
import { clearLocalstorage } from "../../../helper/utils"
import { useResponseHandle } from "../../hooks"

const API = new HelpCenterAPI()

export const getHelpCenterResources = async (params: any) => {
  const { token, dispatch, navigate, loading } = params

  loading(true)
  const response = await API.FetchHelpCenter(token)

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let data: any = {}
      result?.data?.forEach((item: any, index: number) => {
        data[index] = item
      })
      dispatch(data)
    }
    loading(false)
  } else {
    loading(false)
    clearLocalstorage()
    navigate("/auth")
  }
}

export const handleCreateNewResource = async (params: any) => {
  const { token, dispatch, navigate, loading, formData } = params

  if (token) {
    loading(true)
    const response = await API.createNewResource(token, formData)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch(result?.data)
      }
      toast.success("Resource created successfully")
      loading(false)
    } else {
      loading(false)
      clearLocalstorage()
      navigate("/auth")
    }
  }
}
export const handleResourceDirectoryDelete = async (params: any) => {
  const { token, dispatch, navigate, loading, data } = params

  if (token) {
    loading(true)
    const response = await API.deleteDirectory(token, data)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch()
      }
      loading(false)
    } else {
      loading(false)
      clearLocalstorage()
      navigate("/auth")
    }
  }
}
export const handleResourceDocumentDelete = async (params: any) => {
  const { token, dispatch, navigate, loading, data } = params

  if (token) {
    loading(true)
    const response = await API.deleteDocument(token, data)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch()
      }
      loading(false)
    } else {
      loading(false)
      clearLocalstorage()
      navigate("/auth")
    }
  }
}
export const handleEditResource = async (params: any) => {
  const { token, dispatch, navigate, loading, id, data } = params

  if (token) {
    loading(true)
    const response = await API.UpdateResource(token, id, data)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch()
      }
      loading(false)
    } else {
      loading(false)
      clearLocalstorage()
      navigate("/auth")
    }
  }
}
export const handleAddDocument = async (params: any) => {
  const { token, dispatch, navigate, loading, id, data } = params

  if (token) {
    loading(true)
    const response = await API.addAttachmentToResource(token, id, data)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: true,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch(result?.data)
      }
      loading(false)
    } else {
      loading(false)
      clearLocalstorage()
      navigate("/auth")
    }
  }
}
